import { Component, OnInit } from '@angular/core';
import {RecallService} from '../../../../services/recall.service';
import {PatientCaseEndoRecallAutofillModel} from '../../../recall/models/patient-case-endo-recall-autofill.model';
import {PatientCaseEndoRecallAutofillDetailModel} from '../../../recall/models/patient-case-endo-recall-autofill-detail.model';
import {ConfigurationService} from '../../configuration.service';

@Component({
  selector: 'app-recall-configuration',
  templateUrl: './recall-configuration.component.html',
  styleUrls: ['./recall-configuration.component.scss']
})
export class RecallConfigurationComponent implements OnInit {
  isLoading = true;
  autofills: PatientCaseEndoRecallAutofillModel[] = [];
  selectedAutofill: PatientCaseEndoRecallAutofillModel;
  selectedAutofillDetail: PatientCaseEndoRecallAutofillDetailModel;

  constructor(private recallService: RecallService, public configurationService: ConfigurationService) { }

  ngOnInit(): void {
    this.recallService.getAutoFills().subscribe((res) => {
      this.autofills = res;
      if (this.autofills.length > 0) {
        this.selectedAutofill = this.autofills[0];
        this.selectedAutofillDetail = this.autofills[0].cfgPatientCaseEndoRecallAutofillDetails[0];
      }
      this.isLoading = false;
    });
  }

  save() {
    this.recallService.saveAutoFill(this.selectedAutofill).subscribe((res) => {
      this.configurationService.setClean();
    });
  }

  onConfigClick(af: PatientCaseEndoRecallAutofillModel) {
    this.selectedAutofill = af;
    this.selectedAutofillDetail = af.cfgPatientCaseEndoRecallAutofillDetails[0];
  }
}
